@if (locService.localisationInfo !== null) {
  <div>
    <div class="row">
      <div class="col">
        <fieldset class="form-group">
          <div>
            <label>{{'localisations.type' | translate}} @if (required) {
              <span class="star">*</span>
            }</label>
          </div>
          <mat-radio-group [(ngModel)]="locService.localisationInfo.typeLocalisations" (ngModelChange)="updateTypeLocalisation($event)">
            <mat-radio-button class="mr-1" [value]="0">{{'localisations.types.0' | translate}}</mat-radio-button>
            <mat-radio-button class="mr-1" [value]="1">{{'localisations.types.1' | translate}}</mat-radio-button>
            <mat-radio-button class="mr-1" [value]="2">{{ 'localisations.types.2' | translate }}</mat-radio-button>
          </mat-radio-group>
        </fieldset>
      </div>
    </div>
    <!--{{locService.localisationInfo.typeLocalisations | json}} {{locService.localisations.length}} {{locService.localisationInfo.typeLocalisations}}-->
    @if (+locService.localisationInfo.typeLocalisations === 2 && locService.localisations.length && locService.localisationInfo.typeLocalisations !== null) {
      <div>
        <div>
          <div class="row">
            <div class="col">
              <p>{{ 'localisations.ajouter10cancerPrimitif' | translate }} @if (required) {
                <span class="star">*</span>
              } : {{locService.localisationInfo.cancerPrimitifs.length}}/10</p>
              @if (!locService.localisationInfo.cancerPrimitifs.length) {
                <p class="invalid-feedback display-block">
                  {{ 'localisations.vousDevezSaisirAuMoins' | translate }}
                </p>
              }
            </div>
          </div>
          @for (loc of locService.localisationInfo.cancerPrimitifs; track loc; let i = $index) {
            <app-localisation-cancer [passCancerIndex]="i" (removeCancerEvent)="locService.removeCancer(i)" ></app-localisation-cancer>
          }
          <div class="clearfix"></div>
          <div class="row mt-1">
            <div class="col">
              <button class="pull-right" (click)="locService.addCancer()" mat-raised-button color="accent" [disabled]="!isValid() || locService.localisationInfo.cancerPrimitifs.length >=10">{{ 'localisations.ajouterUnCancerPrimitif' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
